import React from "react";
import PopupLoader from "../views/popups/PopupLoader";
import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";

/**
 * Case 1 popup: shown when the currently logged-in user has an import/export
 * operation in progress and tries to perform an action that conflicts with it.
 *
 * Props:
 *   onProceed  - called when the user clicks "Proceed" (redirect to import page)
 *   onCancel   - called when the user clicks "Cancel" or the X button
 */
function ImpExpRedirectPopup({ onProceed, onCancel }) {
  const { t } = useTranslation();
  return (
    <PopupLoader
      title="User Import In Progress"
      content={
        <>
          <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
            <MDBIcon
              fas
              icon="exclamation-triangle"
              className="me-3 fs-5 mt-1"
              color="warning"
            />
            <div
              dangerouslySetInnerHTML={{
                __html: t("imp_exp_own_user_popup_msg"),
              }}
            />
          </div>
          <MDBModalFooter>
            <MDBBtn
              color="secondary"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onCancel();
              }}
            >
              Cancel
            </MDBBtn>
            <MDBBtn
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onProceed();
              }}
            >
              Proceed
            </MDBBtn>
          </MDBModalFooter>
        </>
      }
      onShow={() => {}}
      onClose={onCancel}
    />
  );
}

export default ImpExpRedirectPopup;
